var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 10.5H15H19.5C19.241 8.575 17.844 5.837 16.5 4.5C15.163 3.163 12.925 2.266 11 2M9.5 20V2C7.4 2.266 5.4 2.918 4 4.5C2.6 6.082 1.5 8.865 1.5 11C1.5 13.135 2.1 14.918 3.5 16.5C4.9 18.089 7.4 19.741 9.5 20ZM11 20C12.925 19.755 15.649 18.844 17 17.5C18.344 16.149 19.255 13.425 19.5 11.5H11M10.5 21.5C9.051 21.5 7.686 21.2235 6.405 20.6705C5.131 20.1245 4.0215 19.379 3.0765 18.434C2.1315 17.489 1.3825 16.376 0.8295 15.095C0.2765 13.821 0 12.456 0 11C0 9.544 0.2765 8.179 0.8295 6.905C1.3825 5.631 2.1315 4.5215 3.0765 3.5765C4.0215 2.6315 5.131 1.8825 6.405 1.3295C7.686 0.7765 9.051 0.5 10.5 0.5C11.949 0.5 13.3105 0.7765 14.5845 1.3295C15.8515 1.8825 16.961 2.635 17.913 3.587C18.872 4.539 19.6245 5.6485 20.1705 6.9155C20.7235 8.1895 21 9.551 21 11C21 12.435 20.7235 13.793 20.1705 15.074C19.6245 16.348 18.879 17.461 17.934 18.413C16.989 19.372 15.876 20.1245 14.595 20.6705C13.321 21.2235 11.956 21.5 10.5 21.5Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateCard);
export default __webpack_public_path__ + "static/media/RateCard.aed5b4c9bce941228e584628aef09224.svg";
export { ForwardRef as ReactComponent };